import type { AppRouteRecordRaw } from "shared/types";
import { LAYOUTS, MODULE_SETTINGS, TEACHER_ROLES } from "shared/constants";
import { STUDENT_MEETING_ROUTE_NAMES } from "meetings/student-meeting/routes/routeNames";

/**
 * Meeting route fragment for /my-lessongroups/meetings
 * Import and spread into myLessongroupRoutes.js children array.
 */
export const myLessonGroupsStudentMeetingFragment: AppRouteRecordRaw[] = [
  {
    path: "meetings",
    name: STUDENT_MEETING_ROUTE_NAMES.MY_LESSON_GROUPS,
    component: () =>
      import("meetings/student-meeting/pages/teacher/MyLessonGroupsStudentMeetingPage.vue"),
    meta: {
      title: "Leerlingbespreking",
      isMenuItem: true,
      menuSection: "main",
      settingRequired: [MODULE_SETTINGS.STUDENT_MEETING],
      layout: LAYOUTS.MAIN_NO_WRAPPER,
      exactRouteIdentifier: "myLessongroupsStudentMeetings",
      roleRequired: TEACHER_ROLES,
      hideTitle: true,
    },
  },
];
